<template>
    <transition name="el-fade-in-linear">
    <div v-show="transitionshow">
		<el-form :inline="true" class="backborder1 demo-form-inline" size="small">
			<el-form-item style="width:10%">
				<el-select v-model="query.datetype" @change="changedatetype">
					<el-option v-for="(item,index) in datetype" :key="index" :label="item.name" :value="item.id"></el-option>
				</el-select> 
			</el-form-item>
			
			<!-- 日期 -->
			<el-form-item style="width:12%" v-if="query.datetype==1">
				<el-date-picker v-model="query.starttime" type="date" @change="ischange=true" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择开始日期" style="width:100%"></el-date-picker>
			</el-form-item>
			<el-form-item style="width:12%" v-if="query.datetype==1">
				<el-date-picker v-model="query.endtime" type="date" @change="ischange=true" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择结束日期" style="width:100%"></el-date-picker>
			</el-form-item>
			<!-- 月份 -->
			<el-form-item style="width:12%" v-if="query.datetype==2">
				<el-date-picker v-model="query.starttime" type="month" @change="ischange=true" format="yyyy-MM" value-format="yyyy-MM" placeholder="选择开始日期" style="width:100%"></el-date-picker>
			</el-form-item>
			<el-form-item style="width:12%" v-if="query.datetype==2">
				<el-date-picker v-model="query.endtime" type="month" @change="ischange=true" format="yyyy-MM" value-format="yyyy-MM" placeholder="选择结束日期" style="width:100%"></el-date-picker>
			</el-form-item>
			<!-- 年份 -->
			<el-form-item style="width:12%" v-if="query.datetype==3">
				<el-date-picker v-model="query.starttime" type="year" @change="ischange=true" format="yyyy" value-format="yyyy" placeholder="选择开始日期" style="width:100%"></el-date-picker>
			</el-form-item>
			<el-form-item style="width:12%" v-if="query.datetype==3">
				<el-date-picker v-model="query.endtime" type="year" @change="ischange=true" format="yyyy" value-format="yyyy" placeholder="选择结束日期" style="width:100%"></el-date-picker>
			</el-form-item>

            <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
            </el-form-item>
			<el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="exportdata">导出</el-button>
          	</el-form-item>
      	</el-form>

	    <div class="backborder2" style="margin-top:10px">
	    	<el-table :data="lists" v-loading="listloading">
		        <el-table-column label="时间" prop="time"></el-table-column>
                <el-table-column label="订单数量" prop="nums" align="center" width="150"></el-table-column>
		        <el-table-column label="销售金额" prop="total" width="250" align="center"></el-table-column>
				<el-table-column label="客户数" prop="shopnums" width="250" align="center"></el-table-column>
                <el-table-column label="客单价" prop="orderprice" align="center" width="110"></el-table-column>
	        </el-table>
            <div class="block">
	        	<!--分页begin-->
	            <el-pagination
		            @size-change="orderPageSizeChange"
		            @current-change="orderPageCurrentChange"
		            :current-page="query.p"
		            :page-sizes="[10, 20, 50]"
		            :page-size="query.rollpage"
		            layout="total, sizes, prev, pager, next, jumper"
		            :total="lists_rows">
	            </el-pagination>
	            <!--分页end-->
	      	</div>
        </div>

		<!--------- 按客户导出信息 ------------>
	    <el-dialog title="导出销售日结确认" :visible.sync="exportDialog" width="98%" top="5vh">
	      	<el-button size="medium" type="danger" @click="sureoutput" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
	      	<div id="outputorder">
		      	<el-table :data="exportlists" border v-loading="exportloading">
                    <el-table-column label="时间" prop="time"></el-table-column>
                	<el-table-column label="订单数量" prop="nums" align="center" width="150"></el-table-column>
		       	 	<el-table-column label="销售金额" prop="total" width="250" align="center"></el-table-column>
					<el-table-column label="客户数" prop="shopnums" width="250" align="center"></el-table-column>
                	<el-table-column label="客单价" prop="orderprice" align="center" width="110"></el-table-column>
		      	</el-table>
	      	</div>
	      	<div slot="footer" class="dialog-footer">
		        <el-button size="medium" @click="exportDialog=false">取 消</el-button>
		        <el-button size="medium" type="danger" @click="sureoutput">确认导出</el-button>
		    </div>	                
	    </el-dialog>


	</div>
    </transition>
</template>

<script>
import IEcharts from 'vue-echarts-v3/src/full.js';
export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Mallstat/index",
      transitionshow:true,
      actionauth:[],
	  query: {
		  act:'getdaysalesdata',
		  token:this.$cookies.get('token'),
		  datetype:1,
		  starttime:new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate(),
		  endtime:new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate(),
	  },
	  datetype:[{id:1,name:'按日期'},{id:2,name:'按月份'},{id:3,name:'按年份'}],
	  listsloading:false,
	  lists:[],
	  lists_rows:0,
	  ischange:false,
	  exportDialog:false,
	  exportlists:[],
	  exportloading:false,

    }
  },
  mounted(){    
  	  this.getactionauth(); //获取权限设置
	  this.getList(); //获取销售数据记录
  },
  
  methods:{
    
    /** 获取操作功能权限 **/
  	getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },

	/** 切换时间类型 **/
	changedatetype() {
		this.ischange=true;
		this.query.starttime='';
		this.query.endtime='';
	},

	/** 按时间搜索 **/
	getList() {
		this.malldaysales();	
	},

	/** 获取列表信息 **/
	malldaysales() {
		if(this.ischange==true) {
			this.query.p=1;
			this.query.rollpage=10;
		}

		this.listsloading=true;
		var resource = this.$resource(this.url);
        resource.query(this.query).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
				this.listsloading=false;
			}else{
				this.lists = JSON.parse(Base64.decode(res.data.Data));
				this.lists_rows=parseInt(res.data.count);
				this.listsloading=false;
				if(this.ischange==true) this.ischange=false;
			}
        }).catch((res) => {
			this.listsloading=false;
        });
	},

	orderPageSizeChange(val) {
        this.query.rollpage = val;
        this.malldaysales();
    },
    orderPageCurrentChange(val) {
        this.query.p = val;
        this.malldaysales();
    },


	/** 导出销售记录 **/
    exportdata() {
        this.exportDialog=true;
        this.exportloading=true;
        var resource = this.$resource(this.url);
	    resource.query({act:this.query.act,token:this.query.token,datetype:this.query.datetype,starttime:this.query.starttime,endtime:this.query.endtime}).then((res) => {
		    if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
                this.exportloading=false;
		    }else{
		        this.exportlists = JSON.parse(Base64.decode(res.data.Data));
                this.exportloading=false;
		    }
	    }).catch((res) => {
	        this.exportloading=false;
	    });
    },

    /** 确认导出订单信息 **/
    sureoutput() {
		require.ensure([], () => {
			var { export_json_to_excel } = require('../../vendor/Export2Excel');
			var tHeader = ['时间','订单数量','销售金额','客户数','客单价'];
			var filterVal = ['time','nums','total','shopnums','orderprice'];
				
			var list = this.exportlists;
			var data = this.formatJson(filterVal, list);
			export_json_to_excel(tHeader, data, '线上商城销售日结');
			this.exportDialog=false;
		})
    },
    
    //导出表格数据
	formatJson(filterVal, jsonData) {
　　　　return jsonData.map(v => filterVal.map(j => v[j]));
　　},

	
     
  }
}
</script>

</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/stat/malldaystats.vue